import { render } from "./LoaderComponent.vue?vue&type=template&id=31294346&scoped=true"
import script from "./LoaderComponent.vue?vue&type=script&lang=js"
export * from "./LoaderComponent.vue?vue&type=script&lang=js"

import "./LoaderComponent.vue?vue&type=style&index=0&id=31294346&scoped=true&lang=css"

import exportComponent from "/home/andre/Bureau/projets-nexah/web/vuejs/web/cv-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31294346"]])

export default __exports__